import Hammer from 'hammerjs'

interface InitVerticalSliderParam {
  container: HTMLElement
  slider: HTMLElement
  callback: (nextSliderX: number) => void
  marginLeft?: number
  marginRight?: number
}

export function initVerticalSlider({ container, slider, callback, marginLeft, marginRight }: InitVerticalSliderParam) {
  const manager = new Hammer.Manager(slider)
  manager.add(new Hammer.Pan())

  let beforeOffsetLeft = 0

  manager.on('panstart', () => {
    beforeOffsetLeft = slider.getBoundingClientRect().x
  })

  manager.on('panleft panright', (e: any) => {
    const leftThreshold = container.offsetWidth - slider.offsetWidth
    const nextSliderX = Math.min(
      marginLeft || 0,
      Math.max(beforeOffsetLeft + e.deltaX, leftThreshold - (marginRight || 0))
    )
    callback(nextSliderX)
  })
}

interface InitVerticalSliderBaseCenterParam {
  container: HTMLElement
  slider: HTMLElement
  callback: (nextSliderX: number) => void
  itemWidth: number
}

export function initVerticalSliderBaseCenter({
  container, slider, callback, itemWidth,
}: InitVerticalSliderBaseCenterParam) {
  const manager = new Hammer.Manager(slider)
  manager.add(new Hammer.Pan())

  let beforeOffsetLeft = 0
  let minLeft = 0

  manager.on('panstart', () => {
    const { x, width } = slider.getBoundingClientRect()
    beforeOffsetLeft = x -
      parseInt(getComputedStyle(container).paddingLeft) +
      (itemWidth / 2)
    minLeft = -width + itemWidth
  })

  manager.on('panleft panright', (e: any) => {
    const nextSliderX = Math.max(minLeft, Math.min(beforeOffsetLeft + e.deltaX, 0))
    callback(nextSliderX)
  })
}
